import { render, staticRenderFns } from "./ServicePolicy.vue?vue&type=template&id=5e02727b&scoped=true"
import script from "./ServicePolicy.vue?vue&type=script&lang=js"
export * from "./ServicePolicy.vue?vue&type=script&lang=js"
import style0 from "./ServicePolicy.vue?vue&type=style&index=0&id=5e02727b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02727b",
  null
  
)

export default component.exports